import { useState, useEffect } from 'react';

const AnimatedExamText = () => {
  const [currentBoard, setCurrentBoard] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const boards = ['Cambridge', 'Edexcel'];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      
      // Wait for fade-out (500ms), then switch text
      setTimeout(() => {
        setCurrentBoard((prev) => (prev + 1) % boards.length);
        setIsAnimating(false);
      }, 500);
      
    }, 3000);
    
    return () => clearInterval(interval);
  }, [boards.length]);

  return (
    <h1 className="heading-hero mb-6">
      Excel in
      <br />
      <span 
        className={`inline-block text-aspire-red transition-all duration-500 ${
          isAnimating ? 'opacity-0 -translate-y-2' : 'opacity-100 translate-y-0'
        }`}
      >
        {boards[currentBoard]}
      </span>
      <br />
      Examinations
    </h1>
  );
};

export default AnimatedExamText;
